/**
 * @generated SignedSource<<b2b7b26a6d57fd04b9821bb6b855728b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ContentType = "assignment" | "assignment_submission" | "attachment" | "comment" | "confirmation" | "custom" | "embed" | "module" | "occurrence" | "post" | "quiz" | "survey" | "text" | "video" | "%future added value";
export type ContentUsageEntity = "collection" | "content" | "content_usage_confirmation" | "curriculum" | "dashboard_block_content" | "member_onboarding" | "organization" | "product_app" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type AdminMembersReportAssetUsagesTableRowFragment$data = {
  readonly asset: {
    readonly name: string;
  };
  readonly content: {
    readonly contentLabelId: string | null;
    readonly name: string | null;
    readonly type: ContentType;
    readonly usages: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entity: ContentUsageEntity;
          readonly id: string;
          readonly module: {
            readonly isCollectionModule: boolean;
            readonly isCurriculumModule: boolean;
            readonly name: string | null;
          } | null;
          readonly product: {
            readonly name: string;
          } | null;
        };
      }>;
      readonly totalCount: number;
    };
  } | null;
  readonly highestAssetVideoProgress: {
    readonly maxPercent: number;
  } | null;
  readonly id: string;
  readonly " $fragmentType": "AdminMembersReportAssetUsagesTableRowFragment";
};
export type AdminMembersReportAssetUsagesTableRowFragment$key = {
  readonly " $data"?: AdminMembersReportAssetUsagesTableRowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AdminMembersReportAssetUsagesTableRowFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "organizationMembershipId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AdminMembersReportAssetUsagesTableRowFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Asset",
      "kind": "LinkedField",
      "name": "asset",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contentLabelId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentUsageNodeConnection",
          "kind": "LinkedField",
          "name": "usages",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ContentUsageNodeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ContentUsage",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entity",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Product",
                      "kind": "LinkedField",
                      "name": "product",
                      "plural": false,
                      "selections": (v2/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Content",
                      "kind": "LinkedField",
                      "name": "module",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isCurriculumModule",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isCollectionModule",
                          "storageKey": null
                        },
                        (v1/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "organizationMembershipId",
          "variableName": "organizationMembershipId"
        }
      ],
      "concreteType": "AssetVideoProgress",
      "kind": "LinkedField",
      "name": "highestAssetVideoProgress",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxPercent",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AssetUsage",
  "abstractKey": null
};
})();

(node as any).hash = "c65bb19fa218f176b60a2072b922272b";

export default node;
